import { client } from '@/services/api/axios.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';
import toast from 'react-hot-toast';
import { PowerSchedule } from '@/features/plants/schemas/schedule-plant.schema.ts';
import { AxiosError } from 'axios';

export const useUpdateSchedulePlantMutation = ({ plantId }: { plantId?: string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ schedule }: { schedule?: PowerSchedule }) => {
      if (!plantId || !schedule) return;

      const { data } = await toast.promise(
        async () =>
          await client.patch<{ body: TPlant }>(
            `/plants/${plantId}/schedules/${schedule.scheduleId}`,
            {
              scheduleName: schedule.scheduleName,
              currentStatus: schedule.currentStatus,
              isActive: schedule.isActive,
              weeklySchedule: schedule.weeklySchedule,
              version: schedule.version,
            }
          ),
        {
          loading: 'Updating schedule...',
          success: () => {
            return 'Successfully updated the schedule.';
          },
          error: (
            error: AxiosError<{
              message: string;
            }>
          ) => {
            return `Uh oh, there was an error with updating the schedule. ${error.response?.data?.message}`;
          },
        }
      );

      return data?.body;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['plants', plantId, 'schedules'] });
    },
  });
};
